import { RouteRecordRaw } from 'vue-router';

import { $i } from '@silae/composables';
import { defaultLayoutComponents } from '~/_v3/common/ui/components/layout/layout';
import { RouteKeys } from '~/router/routes.domain.ts';

export const SharesRoute: RouteRecordRaw = {
	name: RouteKeys.SHARES,
	path: '/shares',
	alias: '',
	components: {
		default: () => import('~/_v3/shares/ui/pages/SharesPage.vue'),
		...defaultLayoutComponents
	},
	meta: {
		label: 'shares.navigation',
		icon: () => $i('share'),
		isNavEntry: true,
		order: 1,
		requiresAuth: true
	}
};
